module.exports = __webpack_public_path__ + "img/6.aa07b188.svg";